<!--
 * @Author: zhaozhuo
 * @Date: 2021-12-13 16:30:53
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-06-22 16:01:13
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\utilsComponents\selectPicker\index.vue
-->
<template>
  <div>
    <DhcFieldInput v-model="formOption" :inputData="selectVal" :placeholder="placeholderValue" :disable="disable" @changeFieldData="changeFieldData"></DhcFieldInput>
    <van-popup v-model="formOption.isPopFlag" round position="bottom">
      <van-picker :title="placeholderValue" :default-index="defaultIndex" show-toolbar :columns="columns"
                  value-key="label" @confirm="onSelectValConfirm" @cancel="formOption.isPopFlag = false"
      />
    </van-popup>
  </div>
</template>
<script>
import * as dictionary from '@/assets/js/dictionary'
export default {
	props: {
		index: { // 序号
			type: Number,
			default: 0
		},
		value: {
			type: Object,
			default: {}
		},
		disable: { // 禁止
			type: [Boolean, Number],
			default: false
		},
		placeholderValue: { // placeholder提示
			type: String,
			default: ''
		}
	},
	data() {
		return {
			dictionary,
			selectVal: '', // 下拉框值
			defaultIndex: 0, // 下拉框默认index值
			columns: [] // 下拉框数据
		}
	},
	computed: {
		formOption: {
			get: function() {
				return this.value
			},
			set: function() {
				return
			}
		}
	},
	watch: {
		formOption: {
			handler(newValue) {
				if (newValue.valueType && newValue.valueType === 'group') {
					this.selectVal = ''
					const paramIndex = newValue.itemOptionList.findIndex((item) => {
						return item.groupItemCode === newValue.value
					})
					if (paramIndex >= 0) {
						this.defaultIndex = paramIndex
						this.selectVal = newValue.itemOptionList[paramIndex].groupItemName
					}
				} else {
					this.defaultIndex = newValue.value - 1
					console.log(newValue)
					// console.log(newValue.itemOptionList[newValue.value - 1].optionItemName)
					// console.log(newValue.itemOptionList[newValue.value - 1].groupItemName)
					this.selectVal = (newValue.value ? newValue.itemOptionList[newValue.value - 1].optionItemName
						? newValue.itemOptionList[newValue.value - 1].optionItemName : newValue.itemOptionList[newValue.value - 1].groupItemName : '') || ''
					console.log(this.selectVal)
				}
				if (this.formOption.itemOptionList) {
					this.columns = []
					this.formOption.itemOptionList.map((item) => {
						this.columns.push({
							label: item.optionItemName ? item.optionItemName : item.groupItemName,
							value: item.optionItemValue ? item.optionItemValue : item.groupItemCode
						})
					})
				}
				this.$emit('changePickerData', newValue)
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		// 下拉框数据确认
		onSelectValConfirm(value) {
			this.formOption.value = value.value
			this.selectVal = value.label
			this.formOption.isPopFlag = false
		},
		// 改变input框数据
		changeFieldData(data) {
			this.formOption = data
		}
	}
}
</script>
<style lang="scss" scoped>
</style>